import React from 'react'
import PropTypes from 'prop-types'
import { FormProvider } from 'react-hook-form'

import { useFilterForm } from 'features/filter/hooks'
import { FilterCard } from 'features/filter/components'
import { SENT_JOB_INVITES_FILTERS_INITIAL_VALUES } from 'features/job-invite/consts/filters'
import { FilterForm } from './FilterForm'

export const Filter = ({ defaultValues, onFiltersChange }) => {
  const { methods, isApplied, onReset } = useFilterForm({
    config: {
      defaultValues: {
        ...defaultValues,
      },
    },
    onFiltersChange,
    initialValues: {
      ...SENT_JOB_INVITES_FILTERS_INITIAL_VALUES,
    },
  })

  return (
    <FormProvider {...methods}>
      <FilterCard reset={isApplied} onReset={onReset}>
        <FilterForm />
      </FilterCard>
    </FormProvider>
  )
}

Filter.propTypes = {
  onFiltersChange: PropTypes.func,
  defaultValues: PropTypes.object,
}
